import React, { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import BatchManagement from "./BatchManagement";
import InternPositionManagement from "./InternManagementPosition";

import "./InternStyling.css"; // Import CSS

const InternSetting = () => {
  const [activeTab, setActiveTab] = useState("1");

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div>
      {/* Tab Navigasi */}
      {/* Tab Navigation */}
      <Nav tabs className="custom-tabs">
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "1" })}
            onClick={() => toggleTab("1")}
          >
            MANAGE BATCH
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "2" })}
            onClick={() => toggleTab("2")}
          >
            MANAGE POSITION
          </NavLink>
        </NavItem>
      </Nav>

      {/* Konten Tab */}
      <TabContent activeTab={activeTab} className="mt-3">
        <TabPane tabId="1">
          <BatchManagement />
        </TabPane>
        <TabPane tabId="2">
          <InternPositionManagement />
        </TabPane>
      </TabContent>
    </div>
  );
};

export default InternSetting;
